<div class="container mt-4 py-3">
  <div class="row justify-content-center justify-content-md-between align-items-start">

    <!-- Upload Card - Centered on smaller screens, left on md+ -->
    <div class="col-md-6 order-2 order-md-1 mb-4 mb-md-0">
      <div class="card p-4 shadow-sm">
        <h5 class="card-title mb-3 text-center fw-bold">
          Shop Product Upload
        </h5>

        <!-- Shop Name Dropdown -->
        <div class="form-floating mb-3">
          <select
            class="form-select"
            id="shopName"
            [(ngModel)]="selectedShopId"
          >
            <option value="" disabled selected>Select Shop Name</option>
            <option
              *ngFor="let shop of shopList"
              [value]="shop?.shopDetails?.shopId"
            >
              {{ shop.traderName }}
            </option>
          </select>
          <label for="shopName">
            Select Shop Name <span class="text-danger">*</span>
          </label>
          <span class="text-danger" *ngIf="showShopError && !selectedShopId">
            Please select a shop name.
          </span>
        </div>

        <!-- File Upload -->
        <div class="form-floating mb-3">
          <input
            type="file"
            class="form-control"
            id="productFile"
            (change)="onFileChange($event)"
            [disabled]="!selectedShopId"
            accept=".xls, .xlsx, .csv"
            name="productFileUpload"
          />
          <label for="productFile">
            Upload Product File <span class="text-danger">*</span>
          </label>
          <span class="text-danger" *ngIf="fileError">{{ fileError }}</span>
        </div>

        <!-- Upload Button -->
        <div class="d-grid">
          <button
            type="button"
            class="btn-update custom-upload-button"
            [disabled]="
              !selectedShopId || !selectedFile || fileError || uploading
            "
            (click)="uploadFile()"
          >
            Upload
          </button>
        </div>
      </div>
    </div>

    <!-- Download Card - Right on md+, below on small screens -->
    <div class="col-md-4 order-1 order-md-2 d-flex justify-content-md-end justify-content-center mb-4 mb-md-0">
  <div class="p-4 border rounded shadow-sm bg-light text-center w-100">
    <div class="mb-2">
      <i class="bi bi-file-earmark-arrow-down fs-2 text-primary"></i>
    </div>
    <h6 class="text-secondary">Download Product Upload Template</h6>
    <button class="btn btn-outline-primary mt-2 w-100" (click)="downloadCSVTemplate()">
      <i class="bi bi-download me-1"></i> Download Template
    </button>
  </div>
</div>


  </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium">
  <div class="loader">
    <div class="inner one"></div>
    <div class="inner two"></div>
    <div class="inner three"></div>
  </div>
</ngx-spinner>
